import {connect} from "react-redux"
import State from "../../../../models/State"
import getRealmFromHeaders from "../../../../utils/getRealmFromHeaders"

export const mapStateToProps = (state: State) => {
    const {url, headers, urlIsSaleOrClearance} = state.request
    const {breadcrumbs, breadcrumbsValues} = state.search
    const {text} = state
    const realm = getRealmFromHeaders(headers)
    return {
        url,
        breadcrumbs,
        breadcrumbsValues,
        text,
        realm,
        urlIsSaleOrClearance,
    }
}

export default connect(mapStateToProps)
